import { graphql } from 'gatsby'
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react'
import { Fragment } from 'react'
import tw from 'twin.macro'
import Code from '@/components/ui/code'

export const fragment = graphql`
  fragment CodeTabs on ContentfulComponentCodeTabs {
    __typename
    contentful_id
    code {
      ... on ContentfulComponentCode {
        ...Code
      }
    }
  }
`

export default function CodeTabs({ code }) {
  return (
    <div tw="w-full">
      <TabGroup>
        <TabList tw="flex flex-wrap gap-1 md:gap-4 mb-2">
          {code.map((block) => (
            <Tab as={Fragment}>
              {({ hover, selected }) => (
                <button
                  key={block.contentful_id}
                  type="button"
                  tw="py-1 px-3 border-2 border-white dark:border-gray-700 rounded-3xl"
                  css={[
                    selected && tw`bg-tealBlue border-tealBlue dark:border-tealBlue dark:text-gray-800`,
                    hover && tw`border-tealBlue dark:border-tealBlue`,
                  ]}
                >
                  {block.language}
                </button>
              )}
            </Tab>
          ))}
        </TabList>
        <TabPanels>
          {code.map((block) => (
            <TabPanel tw="w-full [.bw-code-container]:(h-[10rem] text-sm) md:[.bw-code-container]:(h-[clamp(10rem, 50vh, 38rem)] text-base)">
              <Code language={block.language} body={block.body} />
            </TabPanel>
          ))}
        </TabPanels>
      </TabGroup>
    </div>
  )
}
